const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSouthAfrica(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg548",
    viewBox: "0 0 749.41 499.61",
    y: 0,
    x: 0,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g603",
    transform: "matrix(1.9983 0 0 1.9988 -74.837 -1553.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path581",
    style: {
      strokeWidth: "1pt",
      fillRule: "evenodd"
    },
    d: "m37.451 976.39v-148.13l110.28 74.02-110.28 74.11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path597",
    style: {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      fill: "#0000cc"
    },
    d: "m112.7 1027.3l123.8-83.34h175.98v83.34h-299.78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path598",
    style: {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      fill: "#ff0000"
    },
    d: "m112.7 777.32h299.78v83.32h-175.98s-122.16-84.14-123.8-83.32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path599",
    style: {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      fill: "#ffcc00"
    },
    d: "m37.451 808.57v19.69l110.28 74.02-110.28 74.11 0.001 19.68 138.9-93.79-138.9-93.71z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path600",
    style: {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      fill: "#009933"
    },
    d: "m37.451 808.57v-31.25h46.338l147.14 99.53h181.55v50.9h-181.55l-147.14 99.55h-46.339v-31.23l138.9-93.79-138.9-93.71z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path601",
    style: {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      fill: "#ffffff"
    },
    d: "m83.789 777.32h28.911l123.8 83.32h175.98v16.21h-181.55l-147.14-99.53z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path602",
    style: {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      fill: "#ffffff"
    },
    d: "m83.789 1027.3h28.911l123.8-83.34h175.98v-16.21h-181.55l-147.14 99.55z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSouthAfrica);
export default __webpack_public_path__ + "static/media/south-africa.63c3048e121f3b6c62060dea843d6661.svg";
export { ForwardRef as ReactComponent };